import { render } from "./IssuesTable.vue?vue&type=template&id=b93f32b0"
import script from "./IssuesTable.vue?vue&type=script&lang=js"
export * from "./IssuesTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__